import { graphql } from 'react-relay';
import { genericMutation } from '../utils';
import type { TelemetrySync_HubspotUserToken_Mutation } from './__generated__/TelemetrySync_HubspotUserToken_Mutation.graphql';
import type { TelemetrySync_IntegrationsSync_Mutation } from './__generated__/TelemetrySync_IntegrationsSync_Mutation.graphql';

const HubspotUserTokenSync = graphql`
  mutation TelemetrySync_HubspotUserToken_Mutation($input: HsSyncUserTokenInput!) {
    hsSyncUserToken(input: $input) {
      status
    }
  }
`;

export const hubspotUserTokenSyncMutation = genericMutation<TelemetrySync_HubspotUserToken_Mutation>({
  mutation: HubspotUserTokenSync,
});

const TelemetryIntegrationsSync = graphql`
  mutation TelemetrySync_IntegrationsSync_Mutation($input: TelemetryIntegrationsSyncInput!) {
    telemetryIntegrationsSync(input: $input) {
      data {
        key
        value
      }
    }
  }
`;

export const integrationsSyncMutation = genericMutation<TelemetrySync_IntegrationsSync_Mutation>({
  mutation: TelemetryIntegrationsSync,
});
